export default __webpack_public_path__ + "static/media/av5.f5330fd3.jpg";